import { TimelineStatus, TIMELINE_STATUS } from '@customTypes/timeline';

/**
 * Derives status flags from a timeline status
 * @param status - The timeline status
 * @returns Object with isCompleted, isInProgress, and hasProgress flags
 */
export function getStatusFlags(status?: TimelineStatus) {
  const isCompleted = status === TIMELINE_STATUS.COMPLETE;
  const isInProgress = status === TIMELINE_STATUS.IN_PROGRESS;
  return {
    isCompleted,
    isInProgress,
    hasProgress: isCompleted || isInProgress,
  };
}
